import styled from "styled-components";

export const CopyRightsTextWrapper = styled.div`
  overflow: hidden;
  background-color: #032b88;
`;

export const CopyRightsText = styled.p`
  font-family: "Catamaran", sans-serif;
  color: #fff;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  text-transform: capitalize;
  text-align: center;
  margin: 0;
  margin-top: 10px;
  margin-bottom: 10px;
`;
